var classList = require('dom-classlist');
var pubsub = require('pubsub');
var gsap = require('gsap');
var ScrollTo = require('partials/scroll-to');
var project = require('partials/project.js');
var newsletter = require('partials/newsletter.js');

module.exports = function (el) {
	var _el = el
    var _triggerBt = el.querySelector('.triggerAnim.fullSlide')
    ,	_sideContainer = el.querySelector('.side:first-child')
    ,	_contentBase = _sideContainer.querySelector('.content')
    ,	_contentHidden = _sideContainer.querySelector('.content-hidden')
    ,   _slider = _contentHidden.querySelector('.module-slider')
	,	_projectForm = el.querySelector('form.project')
	,	_newsForm = el.querySelector('form#news-form')
    ,	_btClose = el.querySelector('.close')
    ,	tl = new TimelineLite({
        paused:true,
        onReverseComplete: function(){
            //
            pubsub.emit('update:posAnim') //svg-animation.js
        },
        onComplete: function(){
            //
            pubsub.emit('update:posAnim') //svg-animation.js
        }
    })
    ,	isOpened = false 
	,	init = false;

    tl.to(_contentBase, .3, {autoAlpha: 0})
    tl.to(_contentHidden, .3, {autoAlpha: 1, 'position': 'relative'})
	
    function addHandlers(){
		
		if(_triggerBt){
			
			_triggerBt.addEventListener('click', function(e){
				e.preventDefault()
				if(isOpened) return;
				mouseOut()
				tl.play() 
				isOpened = true; 
				setTimeout(function(){
					
					classList(_el).add('open')
				}, 300)
				/*init swiper*/
				if(!init){
					setTimeout(function(){
						pubsub.emit('slider:init', _sideContainer);
						init = true;
					}, 600)
				}
				ScrollTo(_el, 1)
	
			})
		}
    	

    	_btClose.addEventListener('click', function(e){
    		e.preventDefault()
    		classList(_el).remove('open')
    		isOpened = false;
    		tl.reverse()
    		//mouseOut()
    	});

    	if(!G.isMobile && !G.isTablet && _triggerBt){
    		_triggerBt.addEventListener('mouseover', mouseOver)
    		_triggerBt.addEventListener('mouseout', mouseOut)
    	}

		if(_projectForm) project(_projectForm, _el)
		if(_newsForm) newsletter(_newsForm, _el)

		
		

    }

    function mouseOver(){
    	if(isOpened) return;
    	classList(_el).add('hover')
    }

    function mouseOut(){
    	if(isOpened) return;
    	classList(_el).remove('hover')
    }

    addHandlers()
}
